import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FlipkartOffersComponent, RemoveHypen } from './flipkart-offers/flipkart-offers.component';

@NgModule({
  declarations: [
    AppComponent,
    FlipkartOffersComponent,
    RemoveHypen
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
